var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExportDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.188 11.25c.31 0 .562.252.562.563v3.937H2.25v-3.938a.563.563 0 011.125.001v2.812h11.25v-2.813c0-.31.252-.562.563-.562zM9 11.25a.558.558 0 00.563-.563v-7.65l2.407 2.42a.574.574 0 00.405.168.565.565 0 00.394-.169.577.577 0 000-.799L9.394 1.294a.544.544 0 00-.788 0L5.231 4.657a.58.58 0 000 .8.58.58 0 00.8 0l2.407-2.42v7.65c0 .315.247.563.562.563z",
    fill: "#666",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "2e6b0aa3e6c5fe83962aaeaf061cfcdd.svg";
export { SvgIconExportDark as ReactComponent };